/**
 * HPN NAD3 Quiz — Klaviyo config for the reusable tracker (hpn-quiz-tracker.js).
 * Must load before quiz-nad3.js so no early events are missed.
 */
(function () {
  'use strict';

  var GOAL_LABELS = {
    energy: 'Energy',
    focus: 'Focus',
    recovery: 'Recovery',
    sleep: 'Sleep',
    skin: 'Skin / Healthy Aging'
  };

  window.HPNQuizTracker.init({
    rootSelector: '[data-nad3-quiz-root]',
    quizId: 'nad3',
    quizName: 'NAD3 Quiz',
    eventPrefix: 'nad3-quiz:',
    propPrefix: '',
    universal: { age: 'age' },
    aliases: {
      stimulant: 'stimulant_use',
      q5: 'symptoms',
      prior: 'prior_attempt',
      q7: 'costs',
      identity: 'six_month_goal'
    },
    steps: {
      gender: ['gender'],
      goals: ['goals'],
      stimulants: ['stimulant'],
      age: ['age'],
      q5: ['q5'],
      prior: ['prior'],
      q7: ['q7'],
      identity: ['identity']
    },
    viewEvents: ['break1', 'break2'],
    metrics: { 'step-answered': 'Answered NAD3 Quiz Question', 'step-viewed': 'Viewed NAD3 Quiz Break' },
    format: function (key, value) {
      return key === 'goals' && Array.isArray(value)
        ? value.map(function (goal) { return GOAL_LABELS[goal] || goal; })
        : value;
    },
    extra: function (name, detail) {
      if (name === 'step-viewed') {
        return { age_band: detail.ageBand, break2_variant: detail.break2Variant, goal_pair: detail.pairKey };
      }
      if (name !== 'complete') return {};
      return {
        result: detail.sku,
        goal_pair: detail.pairKey,
        age_band: detail.ageBand,
        break2_variant: detail.break2Variant,
        offered_product_title: detail.offeredProductTitle,
        offered_product_handle: detail.offeredProductHandle,
        offered_variant_id: detail.offeredVariantId,
        offered_price: detail.offeredPrice
      };
    }
  });
})();
